export default __webpack_public_path__ + "static/media/speaker.4f4ef1ba.svg";